import React from 'react';

const VideoThumbnail = ({ src, className, ...props }) => {
  return (
    <video
      src={src}
      className={className}
      muted
      playsInline
      preload="metadata"
      onMouseOver={(e) => {
        const p = e.target.play();
        if (p && typeof p.then === 'function') {
           p.catch(() => {});
        }
      }}
      onMouseOut={(e) => e.target.pause()}
      {...props}
    />
  );
};

export default VideoThumbnail;
